import React from 'react';

const ZODIAC_EMOJIS = {
  rat: '\uD83D\uDC00',
  buffalo: '\uD83D\uDC03',
  tiger: '\uD83D\uDC05',
  cat: '\uD83D\uDC08',
  dragon: '\uD83D\uDC09',
  snake: '\uD83D\uDC0D',
  horse: '\uD83D\uDC34',
  goat: '\uD83D\uDC10',
  monkey: '\uD83D\uDC12',
  rooster: '\uD83D\uDC13',
  dog: '\uD83D\uDC15',
  pig: '\uD83D\uDC16'
};

/**
 * Zodiac avatar component for kid profile display
 */
export const ZodiacAvatar = ({ zodiacAnimal, zodiacName, size = 48 }) => (
  <div
    className="rounded-circle bg-primary-subtle d-flex align-items-center justify-content-center flex-shrink-0"
    style={{ width: `${size}px`, height: `${size}px` }}
    title={zodiacName}
  >
    <span style={{ fontSize: `${size / 2}px` }}>
      {ZODIAC_EMOJIS[zodiacAnimal] || '\uD83D\uDC76'}
    </span>
  </div>
);

export default ZodiacAvatar;
